import SVG from 'react-inlinesvg';
import logo from 'assets/icons/logo.svg';
import Tooltip from 'lib/Tooltip';

const YEAR = new Date().getFullYear();

const Logo: React.FC = () => {
  return (
    <div data-test-id="logo" className="block text-center">
      <Tooltip
        tooltip={
          <div className="w-max">
            {/* VERSION is a global variable injected during build by webpack */}
            {/* eslint-disable-next-line prettier/prettier */}
            {/* eslint-disable-line no-undef */}© VIOOH {YEAR} (v{VERSION})
          </div>
        }
      >
        <SVG src={logo} />
      </Tooltip>
    </div>
  );
};

export default Logo;
